const info = {
  email: "info@academymarvel.com",
  text: "شعار ما آموزش برای ایجاد جامعه‌ای توانمند و آگاه",
};
export default info;
